import { AtPixelOptions } from "ol/PluggableMap";
import WaypointLayer from "./WaypointLayer";

export default class WaypointOptions {
    public static atPixelOptions: AtPixelOptions = {
        layerFilter: l => l instanceof WaypointLayer,
        hitTolerance: 5
    }
    
}
